module.exports = __webpack_public_path__ + "static/media/banner-mobile.112da734.png";